import {
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {
  IconColor,
  IconSize,
} from '../../../common/enums/icon.enum';
import {
  ICON_COLOR_CLASS_PREFIX,
  ICON_SIZE_CLASS_PREFIX,
} from '../../../common/constants/icons/sng-icon-mapping';
import {Constants} from '../../../common/constants/constants';

const EXPAND_ICON = {
  EXPAND: 'expand_more',
  COLLAPSE: 'expand_less',
} as const;

@Component({
  selector: 'app-expand-icon',
  imports: [
    MatIcon,
  ],
  templateUrl: './expand-icon.component.html',
  styleUrl: './expand-icon.component.scss',
})
export class ExpandIconComponent {

  public readonly expanded: InputSignal<boolean | null | undefined> = input.required<boolean | null | undefined>();

  public readonly expandIcon: InputSignal<string> = input<string>(EXPAND_ICON.EXPAND);

  public readonly collapseIcon: InputSignal<string> = input<string>(EXPAND_ICON.COLLAPSE);

  public readonly size: InputSignal<IconSize | null> = input<IconSize | null>(null);

  public readonly color: InputSignal<IconColor | null> = input<IconColor | null>(null);

  protected readonly glyph: Signal<string> = computed(() => (this.expanded() ? this.collapseIcon() : this.expandIcon()));

  protected readonly iconClasses: Signal<string> = computed(() => {
    const size = this.size();
    const color = this.color();
    const classes: string[] = [];
    if (size) {
      classes.push(`${ICON_SIZE_CLASS_PREFIX}${size}`);
    }
    if (color) {
      classes.push(`${ICON_COLOR_CLASS_PREFIX}${color}`);
    }
    return classes.join(Constants.SPACE);
  });

}
